<template>
    <div
        v-if="showing"
        class="fixed inset-0 w-full h-screen flex items-center justify-center bg-smoke-200 z-50 w-full"
        @click.self="cancel"
    >

                <div class="flex flex-col w-11/12 sm:w-5/6 lg:w-1/2 max-w-xl mx-auto rounded-lg border-gray-300 shadow-xl">
                    <div class="relative flex flex-row justify-end p-6 bg-white rounded-tl-lg rounded-tr-lg">
                        <button aria-label="close" @click.prevent="cancel">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="bg-white px-6 pb-4 text-2xl text-center text-gray-600">
                        <slot></slot>
                    </div>
                    <div class="grid grid-cols-2 gap-6 px-6 py-5 bg-white rounded-bl-lg rounded-br-lg">
                        <Button color="blue" @click.prevent="confirm">
                            confirm
                        </Button>
                        <Button @click.prevent="cancel">
                            cancel
                        </Button>
                    </div>
                </div>
        </div>
</template>

<script>
import Button from "@/Components/Button";

export default {
    components: {
        Button
    },
    props: {
        showing: {
            required: true,
            type: Boolean
        },
    },
    methods: {
        cancel() {
            this.$emit('close');
        },
        confirm() {
            this.$emit('submit');
        },
    },
    mounted: function() {
        document.addEventListener("keydown", e => {
            if (e.key === "Escape") {
                this.close();
            }
        });
    }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.6s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.bg-smoke-900{background: rgba(0, 0, 0, 0.9);}
.bg-smoke-800{background: rgba(0, 0, 0, 0.75);}
.bg-smoke-600{background: rgba(0, 0, 0, 0.6);}
.bg-smoke{background: rgba(0, 0, 0, 0.5);}
.bg-smoke-400{background: rgba(0, 0, 0, 0.4);}
.bg-smoke-200{background: rgba(0, 0, 0, 0.25);}
.bg-smoke-100{background: rgba(0, 0, 0, 0.1);}

</style>
